<script lang="ts" context="module">
  // keep track of what market id is being shown so that only one market is shown at a time
  const marketIdShown = writable('');
</script>

<script lang="ts">
  import type { BetfairMarket } from '$types/races';
  import { isSubscribed } from '$utils/auth';
  import { formatTotalMatched } from '$utils/prices';
  import { createFloatingActions } from 'svelte-floating-ui';
  import { flip, offset, shift } from 'svelte-floating-ui/core';
  import { writable, type Readable } from 'svelte/store';

  export let marketStore: Readable<BetfairMarket> | undefined;

  const [floatingRef, floatingContent] = createFloatingActions({
    strategy: 'absolute',
    placement: 'right',

    middleware: [offset(-3), flip(), shift()]
  });

  $: sp = Math.round(($marketStore?.sp ?? 0) * 100) / 100;

  let showDialogTimeout: ReturnType<typeof setTimeout>;
  let loadingTimeout: ReturnType<typeof setTimeout>;

  let showDialog = false;
  $: $marketIdShown !== $marketStore?.id && handleMouseLeave(); // hide if another market is shown
  async function handleMouseLeave() {
    clearTimeout(showDialogTimeout);
    clearTimeout(loadingTimeout);
    showDialog = false;
    loading = false;
  }

  let loading = false;
  let fetchMarketData: () => Promise<boolean>;
  async function handleMouseEnter() {
    marketIdShown.set($marketStore?.id ?? '');
    showDialogTimeout = setTimeout(async () => {
      if (!$marketStore?.id) return;
      loading = true;
      loadingTimeout = setTimeout(() => {
        showDialog = true;
      }, 200);
      await fetchMarketData?.();
      loading = false;
      showDialog = true;
    }, 500);
  }
</script>

<td
  on:mouseenter={handleMouseEnter}
  on:mouseleave={handleMouseLeave}
  use:floatingRef
  class="table-cell cursor-pointer select-none whitespace-nowrap text-center text-xs"
>
  {#if sp}
    <div
      class="h-8 w-12 cursor-pointer rounded-sm bg-gray-200 text-center font-medium uppercase tracking-wider text-gray-800 hover:bg-gray-300"
    >
      <div class="flex flex-col px-1">
        <span class="text-xs text-gray-600">SP</span>
        <span class="flex-grow font-semibold">{sp === 0 ? '-' : sp}</span>
      </div>
    </div>
  {/if}
  {#if showDialog && $isSubscribed}
    <div
      use:floatingContent
      class="absolute z-40 flex max-h-72 flex-col overflow-y-auto rounded-sm border bg-white px-4 py-2 font-normal shadow-sm shadow-gray-300"
    >
      <span class="text-[10px] font-semibold">Runner Matched:</span>
      {formatTotalMatched($marketStore?.totalMatched ?? 0)}
    </div>
  {/if}
</td>
